import {fetch} from '../utils/fetch'
import {casaApiUrl} from '../configs/casa-api'
import walkInInterestService from '../services/walk-in-interests-service'
import queryString from 'query-string'
import moment from 'moment'
import {saveAs} from 'file-saver'

function getLoyaltyTierConfigs(businessUnitId) {
  return fetch(`${casaApiUrl}/users/loyalty/businessUnit/${businessUnitId}/tier/configs`, {
    method: 'GET',
    credentials: 'include',
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    if (response.status === 200) {
      return response.json()
    } else {
      return Promise.reject('login failed')
    }
  })
}

function getLoyaltyTierStat(businessUnitId) {
  return fetch(`${casaApiUrl}/users/loyalty/businessUnit/${businessUnitId}/tier/stat`, {
    method: 'GET',
    credentials: 'include',
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    if (response.status === 200) {
      return response.json()
    } else {
      return Promise.reject('login failed')
    }
  })
}

function saveLoyaltyTierConfig(tierConfig, businessUnitId) {
  return fetch(`${casaApiUrl}/users/loyalty/businessUnit/${businessUnitId}/tier/config`, {
    method: 'POST',
    body: JSON.stringify(tierConfig),
    credentials: 'include',
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    if (response.status === 200) {
      return response.json()
    } else {
      return Promise.reject('login failed')
    }
  })
}

function adhocAddLoyaltyPoints({mobile, points, type, billNumber, channel, description, billDateTime, expireInDays, storeCode}, businessUnitId) {
  return fetch(`${casaApiUrl}/users/loyalty/businessUnit/${businessUnitId}/adhoc/award`, {
    method: 'POST',
    body: JSON.stringify({
      points: points,
      customerMobile: mobile,
      description: description,
      billDate: billDateTime,
      channel: channel,
      expireInDays: expireInDays,
      type: type,
      billId: billNumber,
      storeName: storeCode
    }),
    credentials: 'include',
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    if (response.status === 200) {
      return response.json()
    } else {
      return response.json()
    }
  })
}

function adhocRedeemLoyaltyPoints({mobile, points, channel, type, billNumber, originalBillNumber, description, billDateTime, originalBillDateTime, storeCode}, businessUnitId) {
  return fetch(`${casaApiUrl}/users/loyalty/businessUnit/${businessUnitId}/adhoc/redeem`, {
    method: 'POST',
    body: JSON.stringify(
      {
        'transactionId': billNumber,
        'transactionDate': billDateTime,
        'channel': channel,
        'storeCode': storeCode,
        'customerMobile': mobile,
        'pointsToRedeem': points,
        'otpCode': '1111'
      }
      ),
    credentials: 'include',
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    if (response.status === 200) {
      return response.json()
    } else {
      return Promise.reject('login failed')
    }
  })
}

function getLoyaltyTierStatSplit(businessUnitId) {
  return fetch(`${casaApiUrl}/users/loyalty/businessUnit/${businessUnitId}/tier/stat/split`, {
    method: 'GET',
    credentials: 'include',
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    if (response.status === 200) {
      return response.json()
    } else {
      return Promise.reject('login failed')
    }
  })
}

function getLoyaltyPointsWithExpiryDetails(mobileNumber, businessUnitId) {
  let query = queryString.stringify({
    mobile: mobileNumber
  }, {arrayFormat: 'bracket'})
  return fetch(`${casaApiUrl}/users/loyalty/businessUnit/${businessUnitId}/customerWithPointsExpiryInfo?${query}`, {
    method: 'GET',
    credentials: 'include',
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    if (response.status === 200) {
      return response.json()
    } else {
      return Promise.reject('login failed')
    }
  })
}

function getLoyaltyTierConfig(businessUnitId) {
  return fetch(`${casaApiUrl}/users/loyalty/businessUnit/${businessUnitId}/tier/configs`, {
    method: 'GET',
    credentials: 'include',
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    if (response.status === 200) {
      return response.json()
    } else {
      return Promise.reject('login failed')
    }
  })
}

function getHistoryFilter(filter) {
  let {startDate, endDate, storeNames, brand, brandBusiness, download} = filter.toJSON()
  let startDateParam = moment(startDate).format('YYYY-MM-DD')
  let endDateParam = moment(endDate).format('YYYY-MM-DD')
  let query = queryString.stringify({
    stores: storeNames,
    startDate: startDateParam,
    endDate: endDateParam,
    brandName: _.lowerCase(brand.name),
    businessUnitName: _.lowerCase(brandBusiness.name),
    download: download
  }, {arrayFormat: 'bracket'})
  return query
}

function getLoyaltyEarnedSummary(filter) {
  let loyaltyFilter = getHistoryFilter(filter)
  return fetch(`${casaApiUrl}/users/loyalty/earn/history?${loyaltyFilter}`, {
    method: 'GET',
    credentials: 'include',
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    if (response.status === 200) {
      return response.json()
    } else {
      return Promise.reject('login failed')
    }
  })
}

function getLoyaltyRedeemedSummary(filter) {
  let loyaltyFilter = getHistoryFilter(filter)
  return fetch(`${casaApiUrl}/users/loyalty/redeem/history?${loyaltyFilter}`, {
    method: 'GET',
    credentials: 'include',
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    if (response.status === 200) {
      return response.json()
    } else {
      return Promise.reject('login failed')
    }
  })
}

function downloadLoyaltyEarnedSummaryCSV(filter, name) {
  let loyaltyFilter = getHistoryFilter(filter)
  return fetch(`${casaApiUrl}/users/loyalty/earn/history?${loyaltyFilter}`, walkInInterestService.csvDownloadOptions).then(res => res.blob())
    .then(blob => saveAs(blob, `${name}.csv`))
    .catch(() => {})
}

function downloadLoyaltyRedeemedSummaryCSV(filter, name) {
  let loyaltyFilter = getHistoryFilter(filter)
  return fetch(`${casaApiUrl}/users/loyalty/redeem/history?${loyaltyFilter}`, walkInInterestService.csvDownloadOptions).then(res => res.blob())
    .then(blob => saveAs(blob, `${name}.csv`))
    .catch(() => {})
}

function getUserLoyaltyPoints(mobileNumber, businessUnitId) {
  let query = queryString.stringify({
    mobile: mobileNumber
  }, {arrayFormat: 'bracket'})
  return fetch(`${casaApiUrl}/users/loyalty/businessUnit/${businessUnitId}/customerLoyaltyDetails?${query}`, {
    method: 'GET',
    credentials: 'include',
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    if (response.status === 200) {
      return response.json()
    } else {
      return Promise.reject('login failed')
    }
  })
}

function getUserLoyaltyPointsRedeem(mobileNumber, businessUnitId) {
  let query = queryString.stringify({
    mobile: mobileNumber
  }, {arrayFormat: 'bracket'})
  return fetch(`${casaApiUrl}/users/loyalty/businessUnit/${businessUnitId}/customer?${query}`, {
    method: 'GET',
    credentials: 'include',
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    if (response.status === 200) {
      return response.json()
    } else {
      return Promise.reject('login failed')
    }
  })
}

function redeemLoyaltyPoints(businessUnitId, body) {
  return fetch(`${casaApiUrl}/users/loyalty/businessUnit/${businessUnitId}/redeem`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    return response.json()
  })
}

function getTenantOfferOtpConfig(tenantName) {
  return fetch(`${casaApiUrl}/users/tenant-configs/?type=offerOtp&tenant=${tenantName}`, {
    method: 'GET',
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    return response.json()
  })
}

export default {
  getLoyaltyTierConfigs,
  saveLoyaltyTierConfig,
  adhocAddLoyaltyPoints,
  adhocRedeemLoyaltyPoints,
  getLoyaltyTierStat,
  getLoyaltyTierStatSplit,
  getLoyaltyPointsWithExpiryDetails,
  getLoyaltyTierConfig,
  getLoyaltyEarnedSummary,
  getLoyaltyRedeemedSummary,
  downloadLoyaltyEarnedSummaryCSV,
  downloadLoyaltyRedeemedSummaryCSV,
  getUserLoyaltyPoints,
  getUserLoyaltyPointsRedeem,
  redeemLoyaltyPoints,
  getTenantOfferOtpConfig
}



// WEBPACK FOOTER //
// ./src/services/loyalty-service.js